var map = {
	".": [
		6,
		9
	],
	"./": [
		6,
		9
	],
	"./assets/Info.svg": [
		59,
		7,
		52
	],
	"./assets/adult-selection.svg": [
		77,
		7,
		53
	],
	"./assets/appleSSOIcon.svg": [
		65,
		7,
		54
	],
	"./assets/arduino-minor-signin.jpg": [
		78,
		7,
		69
	],
	"./assets/arduino-minor-signinx2.jpg": [
		79,
		7,
		70
	],
	"./assets/background.jpg": [
		80,
		7,
		71
	],
	"./assets/backgroundx2.jpg": [
		81,
		7,
		72
	],
	"./assets/carousel_dashboard.svg": [
		82,
		7,
		55
	],
	"./assets/carousel_device.svg": [
		83,
		7,
		56
	],
	"./assets/carousel_project.svg": [
		84,
		7,
		57
	],
	"./assets/child-background.png": [
		85,
		7,
		73
	],
	"./assets/danger-icon.svg": [
		53,
		7,
		58
	],
	"./assets/download-icon.svg": [
		72,
		7,
		59
	],
	"./assets/facebookSSOIcon.svg": [
		66,
		7,
		60
	],
	"./assets/githubSSOIcon.svg": [
		67,
		7,
		61
	],
	"./assets/googleSSOIcon.svg": [
		68,
		7,
		62
	],
	"./assets/info-icon.svg": [
		54,
		7,
		63
	],
	"./assets/kid-selection.svg": [
		86,
		7,
		64
	],
	"./assets/logo.svg": [
		87,
		7,
		65
	],
	"./assets/otp-icon.svg": [
		88,
		7,
		66
	],
	"./assets/recovery-icon.svg": [
		89,
		7,
		67
	],
	"./assets/recovery.svg": [
		90,
		7,
		68
	],
	"./auth/authService": [
		26,
		9,
		4,
		29
	],
	"./auth/authService.js": [
		26,
		9,
		4,
		29
	],
	"./components/Sso": [
		42,
		9,
		0,
		1,
		2,
		3,
		6
	],
	"./components/Sso.jsx": [
		42,
		9,
		0,
		1,
		2,
		3,
		6
	],
	"./components/Sso.scss": [
		74,
		7,
		34
	],
	"./components/common/AlertBox": [
		21,
		9,
		22
	],
	"./components/common/AlertBox.jsx": [
		21,
		9,
		22
	],
	"./components/common/AlertBox.scss": [
		55,
		7,
		35
	],
	"./components/common/InfoIcon": [
		25,
		9,
		24
	],
	"./components/common/InfoIcon.jsx": [
		25,
		9,
		24
	],
	"./components/common/InfoIcon.scss": [
		60,
		7,
		36
	],
	"./components/common/LoadingSpinner": [
		28,
		9,
		23
	],
	"./components/common/LoadingSpinner.jsx": [
		28,
		9,
		23
	],
	"./components/common/LoadingSpinner.scss": [
		62,
		7,
		37
	],
	"./components/layout/ChildAside": [
		23,
		9,
		25
	],
	"./components/layout/ChildAside.jsx": [
		23,
		9,
		25
	],
	"./components/layout/ChildAside.scss": [
		57,
		7,
		38
	],
	"./components/layout/Header": [
		24,
		9,
		2,
		26
	],
	"./components/layout/Header.jsx": [
		24,
		9,
		2,
		26
	],
	"./components/layout/Header.scss": [
		56,
		7,
		39
	],
	"./components/layout/Layout": [
		22,
		9,
		2,
		20
	],
	"./components/layout/Layout.jsx": [
		22,
		9,
		2,
		20
	],
	"./components/layout/Layout.scss": [
		58,
		7,
		40
	],
	"./components/pages/Login/Login": [
		37,
		9,
		0,
		1,
		2,
		3,
		8
	],
	"./components/pages/Login/Login.jsx": [
		37,
		9,
		0,
		1,
		2,
		3,
		8
	],
	"./components/pages/Login/LoginBanners": [
		43,
		9,
		30
	],
	"./components/pages/Login/LoginBanners.js": [
		43,
		9,
		30
	],
	"./components/pages/Login/LoginForm": [
		33,
		9,
		0,
		1,
		3,
		4,
		13
	],
	"./components/pages/Login/LoginForm.jsx": [
		33,
		9,
		0,
		1,
		3,
		4,
		13
	],
	"./components/pages/Login/LoginForm.scss": [
		70,
		7,
		41
	],
	"./components/pages/Login/LoginSelector/LoginSelector": [
		32,
		9,
		0,
		2,
		3,
		19,
		27
	],
	"./components/pages/Login/LoginSelector/LoginSelector.jsx": [
		32,
		9,
		0,
		2,
		3,
		19,
		27
	],
	"./components/pages/Login/LoginSelector/LoginSelector.scss": [
		69,
		7,
		42
	],
	"./components/pages/Recover/Recover": [
		38,
		9,
		0,
		1,
		2,
		3,
		10
	],
	"./components/pages/Recover/Recover.jsx": [
		38,
		9,
		0,
		1,
		2,
		3,
		10
	],
	"./components/pages/Recover/Recover.scss": [
		73,
		7,
		43
	],
	"./components/pages/Register/AgeGate": [
		35,
		9,
		0,
		1,
		28
	],
	"./components/pages/Register/AgeGate.jsx": [
		35,
		9,
		0,
		1,
		28
	],
	"./components/pages/Register/AgeGate.scss": [
		71,
		7,
		44
	],
	"./components/pages/Register/CoppaRegister/CoppaRegister": [
		36,
		9,
		0,
		1,
		2,
		3,
		11
	],
	"./components/pages/Register/CoppaRegister/CoppaRegister.jsx": [
		36,
		9,
		0,
		1,
		2,
		3,
		11
	],
	"./components/pages/Register/CoppaRegister/RegisterFormCoppa": [
		31,
		9,
		0,
		1,
		2,
		15
	],
	"./components/pages/Register/CoppaRegister/RegisterFormCoppa.jsx": [
		31,
		9,
		0,
		1,
		2,
		15
	],
	"./components/pages/Register/CoppaRegister/RegisterFormCoppa.scss": [
		64,
		7,
		45
	],
	"./components/pages/Register/Register": [
		41,
		9,
		0,
		1,
		2,
		3,
		7
	],
	"./components/pages/Register/Register.jsx": [
		41,
		9,
		0,
		1,
		2,
		3,
		7
	],
	"./components/pages/Register/SendParentEmailForm": [
		27,
		9,
		0,
		1,
		21
	],
	"./components/pages/Register/SendParentEmailForm.jsx": [
		27,
		9,
		0,
		1,
		21
	],
	"./components/pages/Register/SendParentEmailForm.scss": [
		61,
		7,
		46
	],
	"./components/pages/Register/UserRegister/RegisterForm": [
		30,
		9,
		0,
		1,
		17
	],
	"./components/pages/Register/UserRegister/RegisterForm.jsx": [
		30,
		9,
		0,
		1,
		17
	],
	"./components/pages/Register/UserRegister/RegisterForm.scss": [
		63,
		7,
		47
	],
	"./components/pages/Register/UserRegister/UserRegister": [
		34,
		9,
		0,
		1,
		2,
		3,
		9
	],
	"./components/pages/Register/UserRegister/UserRegister.jsx": [
		34,
		9,
		0,
		1,
		2,
		3,
		9
	],
	"./components/pages/ResetPwd/ResetPwd": [
		44,
		9,
		0,
		1,
		2,
		14
	],
	"./components/pages/ResetPwd/ResetPwd.jsx": [
		44,
		9,
		0,
		1,
		2,
		14
	],
	"./components/pages/ResetPwd/ResetPwd.scss": [
		75,
		7,
		48
	],
	"./components/pages/TwoFactor/AuthAppToken": [
		39,
		9,
		0,
		1,
		18
	],
	"./components/pages/TwoFactor/AuthAppToken.jsx": [
		39,
		9,
		0,
		1,
		18
	],
	"./components/pages/TwoFactor/AuthWithRecovery": [
		40,
		9,
		0,
		1,
		16
	],
	"./components/pages/TwoFactor/AuthWithRecovery.jsx": [
		40,
		9,
		0,
		1,
		16
	],
	"./components/pages/TwoFactor/TwoFactor": [
		45,
		9,
		0,
		1,
		2,
		5,
		12
	],
	"./components/pages/TwoFactor/TwoFactor.jsx": [
		45,
		9,
		0,
		1,
		2,
		5,
		12
	],
	"./components/pages/TwoFactor/TwoFactor.scss": [
		76,
		7,
		49
	],
	"./i18n": [
		13,
		9
	],
	"./i18n.js": [
		13,
		9
	],
	"./index": [
		6,
		9
	],
	"./index.jsx": [
		6,
		9
	],
	"./locales/en": [
		12,
		9
	],
	"./locales/en.js": [
		12,
		9
	],
	"./serviceWorker": [
		11,
		9
	],
	"./serviceWorker.js": [
		11,
		9
	],
	"./style/breakpoint.scss": [
		91,
		7,
		50
	],
	"./style/utils.scss": [
		92,
		7,
		51
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 51;
module.exports = webpackAsyncContext;